export default __webpack_public_path__ + "static/media/HolidayIcon.5df615b4.svg";